import { Box, Typography } from '@mui/material';
import React from 'react';
import { DATA_TYPE_META } from '../stores/graphStore';

const TOOLTIP_OFFSET = 12;

function formatTime(date, unit = 'hh:mm:ss') {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const totalSec = Math.max(0, Math.floor(date.getTime() / 1000));
  if (unit === 'seconds') return String(totalSec);
  const hh = String(Math.floor(totalSec / 3600)).padStart(2, '0');
  const mm = String(Math.floor((totalSec % 3600) / 60)).padStart(2, '0');
  const ss = String(totalSec % 60).padStart(2, '0');
  return unit === 'hh:mm' ? `${hh}:${mm}` : `${hh}:${mm}:${ss}`;
}

function signalLabel(signalType) {
  if (!signalType) return '—';
  return DATA_TYPE_META[signalType]?.label ?? signalType;
}

const Row = ({ label, value }) => (
  <>
    <Typography sx={{ fontSize: 12, color: '#7d8d97' }}>{label}</Typography>
    <Typography sx={{ fontSize: 12, color: '#394b57', textAlign: 'right' }}>{value}</Typography>
  </>
);

const MarkInfoTooltip = ({ mark, x, y, containerWidth, containerHeight, xUnit }) => {
  if (!mark) return null;

  const start = mark.start instanceof Date ? mark.start : new Date(mark.start);
  const end = mark.end instanceof Date ? mark.end : new Date(mark.end ?? mark.start);
  const startStr = formatTime(start, xUnit);
  const endStr = mark.mark_type === 'MOMENT' ? '—' : formatTime(end, xUnit);
  const points = typeof mark.n_points === 'number' ? mark.n_points : '—';

  // Estimated tooltip box size — used to flip the box to avoid overflowing
  // the container's right or bottom edges.
  const TOOLTIP_W = 220;
  const TOOLTIP_H = 130;
  const flipLeft = containerWidth != null && x + TOOLTIP_W + TOOLTIP_OFFSET > containerWidth;
  const flipUp = containerHeight != null && y + TOOLTIP_H + TOOLTIP_OFFSET > containerHeight;
  const left = flipLeft ? Math.max(0, x - TOOLTIP_W - TOOLTIP_OFFSET) : x + TOOLTIP_OFFSET;
  const top = flipUp ? Math.max(0, y - TOOLTIP_H - TOOLTIP_OFFSET) : y + TOOLTIP_OFFSET;

  return (
    <Box
      sx={{
        position: 'absolute',
        left,
        top,
        width: TOOLTIP_W,
        background: 'rgba(255, 255, 255, 0.92)',
        border: '1px solid #dde3e6',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(57, 75, 87, 0.18)',
        padding: '10px 12px',
        pointerEvents: 'none',
        zIndex: 3,
      }}
    >
      <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#394b57', marginBottom: '6px' }}>
        {mark.name || 'Mark'}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          columnGap: '12px',
          rowGap: '3px',
        }}
      >
        <Row label="State" value={mark.state ?? '—'} />
        <Row label="Signal" value={signalLabel(mark.mark_signal_type)} />
        <Row label="Start" value={startStr} />
        <Row label="End" value={endStr} />
        <Row label="Points" value={points} />
      </Box>
    </Box>
  );
};

export default MarkInfoTooltip;
